// Fan vs Contestant experience helpers. `account_type === "fan"` gets a
// spectator-first app; everything else (default) is the full contestant app.
export const isFan = (user) => user?.account_type === "fan";

// Contestant-only destinations hidden from fans (nav) and blocked from fans (routes).
// Everything NOT in this set stays available to fans (Today, My Riders, Weekly, Map,
// Calendar, Table, Standings, CFR, Results, Top Money, Directory, Stock, rodeo detail…).
export const FAN_BLOCKED = new Set([
  "/my-rodeos",
  "/planner",
  "/route-mapper",
  "/rodeo-counts",
  "/trades",
  "/goals",
  "/bank",
  "/stats",
  "/deadlines",
  "/entry-dates",
  "/prca",
]);

// Additionally hidden from the FAN MENU only (still reachable by URL / profile link —
// a fan is a spectator, so these athlete/entry views just add noise to their nav).
export const FAN_NAV_HIDE = new Set([
  ...FAN_BLOCKED,
  "/table",
  "/calendar",
  "/map",
  "/season",
  "/wallet",
]);
